import BaseRepository from './base.repository';

class NoteAIRepository extends BaseRepository {
  constructor() {
    super('note-ai');
  }

  /**
   * Generate / retrieve note_ai_block for a stock.
   * Cache-first + queue mode: when useQueue=true, always enqueues via BullMQ
   * and returns immediately with { status: 'pending' }.
   *
   * @param {Object} data
   * @param {string} data.stock_code - Stock code (e.g. 'VND')
   * @param {Object} data.row_snapshot - Pre-built row snapshot from Question Engine
   * @param {Object|null} data.question_context - { question_code, question_label, group_code, group_label }
   * @param {boolean} [data.useQueue=false] - If true, always enqueue via BullMQ (non-blocking)
   * @returns {Promise} { code, message, payload: { stock_code, job_id, status, cached, ... } }
   */
  generate({ stock_code, row_snapshot, question_context, useQueue = false }) {
    const url = useQueue ? '/generate?queue=true' : '/generate';
    return this.client.post(url, {
      stock_code,
      row_snapshot,
      question_context,
    });
  }

  /**
   * Poll job status after /generate returns status: 'pending'.
   *
   * @param {string} jobId - Job ID (e.g. 'note-ai:VND:20260403')
   * @returns {Promise} { code, message, payload: { job_id, status, note_ai_block?, completedAt? } }
   */
  getStatus(jobId) {
    return this.client.get(`/job/${jobId}`);
  }
}

export default new NoteAIRepository();
